import { Card } from '../Card'
import Styles from './ReviewRequestCard.module.scss'
import { InformalFeedbackRequest, InformalFeedbackReview } from 'api/clients/InformalFeedbackRequestsClient'
import { Text } from 'blaze-ui/Text/Text'
import { RequestCard } from 'components/ReviewSummaryModal/RequestCard'
import { ProseDisplay } from 'common/ProseInput/ProseDisplay'
import { displayDateFrom } from 'utils/dates'
import { reviewResult } from 'components/ReviewSummaryModal/utils'
import { Header } from './Header'
import { lowerCase } from 'lodash'
import { Content } from './Content'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { ViewSummaryButton } from './Buttons/ViewSummaryButton'
import cx from 'classnames'
interface Props {
  request: InformalFeedbackRequest
  review: InformalFeedbackReview
}

export const ReviewerSubmittedCard = ({ request, review }: Props) => {
  const { isMobile } = useResponsiveDesign()
  const reviewResultKey = review.score || review.dismissed_reason
  const reviewScore = reviewResultKey && reviewResult[reviewResultKey]

  return (
    <Card className={cx(Styles.reviewRequestCard, { [Styles.isDesign]: !!request.design })}>
      <Header status={`Due ${displayDateFrom(request.ends_on)}`} />
      <Content request={request}>
        <div className={Styles.titleContainer}>
          <div className={Styles.yourResult}>
            {reviewScore?.iconSmall}
            <Text variant="largeList" color="var(--dark-80)">
              You {lowerCase(reviewScore?.label)}
            </Text>
          </div>
          <Text variant="secondary" color="var(--dark-60)">
            {review.submitted_at && displayDateFrom(review.submitted_at)}
          </Text>
        </div>
        {review.message && (
          <RequestCard.Message>
            <ProseDisplay html={review.message} />
          </RequestCard.Message>
        )}
      </Content>
      <ViewSummaryButton request={request} variant={isMobile ? 'secondary' : 'tertiary'} fullWidth />
    </Card>
  )
}
